import { apiUTCToLocalDateTime, cx, useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import format from "date-fns/format";
import { ReactComponent as PinIcon } from "./assets/pin.svg";
import { ReactComponent as CheckIcon } from "./assets/check.svg";
import { ReactComponent as EyeOutlineIcon } from "./assets/eye-outline.svg";
import { ReactComponent as SandClockIcon } from "./assets/sand-clock.svg";
import { ReactComponent as SendFailedInfoIcon } from "./assets/send-failed-info.svg";
import { useChatMessageBubble } from "../../providers/ChatMessageBubbleProvider/useChatMessageBubble";

export const ChatMessageFooter: FC = () => {
  const { t } = useTranslations();
  const {
    isOutgoing,
    isMediaMessageOnly,
    timestamp,
    isEdited,
    outgoingStatus,
    isError,
    isPending,
    isPinned,
    isDeleted,
  } = useChatMessageBubble();
  const timeStr = format(apiUTCToLocalDateTime(timestamp), "p");
  const mediaOnlyBg =
    isOutgoing && isError && !isPending
      ? `rgba(229, 83, 83, 0.6)`
      : `rgba(26, 32, 35, 0.30)`;
  return (
    <div
      className={cx(
        "z-10 flex items-center justify-end gap-1 font-secondary text-xs",
        {
          "text-[#707577]": !isOutgoing && !isMediaMessageOnly,
          "text-white": isOutgoing || isMediaMessageOnly,
          "bg-[rgba(26, 32, 35, 0.30)] absolute right-[6px] bottom-2 rounded px-1 py-[2px] text-white":
            isMediaMessageOnly,
        }
      )}
      style={{
        background: isMediaMessageOnly ? mediaOnlyBg : undefined,
      }}
    >
      {isPinned && <PinIcon />}
      {isEdited && !isDeleted && (
        <>
          <span>
            {t({
              id: "chats-page.edited",
              defaultMessage: "Edited",
            })}
          </span>
          <span
            className={cx("h-[2px] w-[2px] rounded-full", {
              "bg-[#707577]": !isOutgoing && !isMediaMessageOnly,
              "bg-white": isOutgoing || isMediaMessageOnly,
            })}
          />
        </>
      )}
      <span>{timeStr}</span>
      {(() => {
        if (!isOutgoing || isDeleted) return null;

        if (isError && isMediaMessageOnly && !isPending) {
          return <SendFailedInfoIcon />;
        }
        if (isError && !isPending) {
          return (
            <>
              {t({
                id: "chats-page.failed-tap-to-retry",
                defaultMessage: "Failed. Tap to retry.",
              })}{" "}
              <SendFailedInfoIcon />
            </>
          );
        }
        if (outgoingStatus === "pending") {
          return <SandClockIcon />;
        }
        if (outgoingStatus === "read") {
          return <EyeOutlineIcon />;
        }
        return <CheckIcon />;
      })()}
    </div>
  );
};
